var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarouselSlide',{staticClass:"before-slide"},[_c('FeaturesList',{staticClass:"before-slide__list",attrs:{"title":"Було","list-type":"simple","items":_vm.getBeforeItems,"image-components":_vm.getBeforeImageComponents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }